import { Injectable, Inject } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { of } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class TypeDocumentService {

    className = 'TypeDocumentService';

    constructor(private http: HttpClient, @Inject("environment") private environment: any) { }

    getAll(): any {
        //return this.http.get(this.environment.base_URL + "/types-document");
        return of([
            {
                "txtName": "INFORME"
            },
            {
                "txtName": "NOTA"
            }
        ])
    }

}